import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ClientMiniDto,
  InvoicingProjectAccount,
  InvoicingProjectAccountRequest,
  ProjectMiniDto
} from '../models/invoicing-project-account.model';

export interface IbbiolImportJobStartResponse {
  jobId: string;
  status: string;
}

export interface IbbiolImportJobStatusResponse {
  jobId: string;
  status: string;
  totalRows: number;
  imported: number;
  skipped: number;
  failed: number;
  startedAtEpochMs: number;
  completedAtEpochMs: number | null;
  message: string;
  errors: string[];
}

@Injectable({
  providedIn: 'root'
})
export class InvoicingProjectAccountService {
  private readonly apiUrl = `${environment.apiUrl}/invoicing-accounts`;

  constructor(private http: HttpClient) { }
  getAllAccounts(): Observable<InvoicingProjectAccount[]> {
    return this.http.get<InvoicingProjectAccount[]>(this.apiUrl);
  }

  updateAccount(id: number, account: InvoicingProjectAccountRequest): Observable<InvoicingProjectAccount> {
    return this.http.put<InvoicingProjectAccount>(`${this.apiUrl}/${id}`, account);
  }

  deleteAccount(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
  createAccount(account: InvoicingProjectAccountRequest): Observable<InvoicingProjectAccount> {
    return this.http.post<InvoicingProjectAccount>(this.apiUrl, account);
  }
  activateAccount(id: number): Observable<any> {
  return this.http.put(`${this.apiUrl}/${id}/activate`, {});
}

deactivateAccount(id: number): Observable<any> {
  return this.http.put(`${this.apiUrl}/${id}/deactivate`, {});
}

getClientsForDropdown(): Observable<ClientMiniDto[]> {
  return this.http.get<ClientMiniDto[]>(`${environment.apiUrl}/clients/list`);
}

getProjectsForDropdown(): Observable<ProjectMiniDto[]> {
  return this.http.get<ProjectMiniDto[]>(`${environment.apiUrl}/project/list`);
}

importIbbiolFile(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('file', file);
  return this.http.post(`${this.apiUrl}/import-ibbiol`, formData).pipe(
    timeout(1800000)
  );
}

startIbbiolImportJob(file: File): Observable<IbbiolImportJobStartResponse> {
  const formData = new FormData();
  formData.append('file', file);
  return this.http.post<IbbiolImportJobStartResponse>(`${this.apiUrl}/import-ibbiol/async`, formData);
}

getIbbiolImportJobStatus(jobId: string): Observable<IbbiolImportJobStatusResponse> {
  return this.http.get<IbbiolImportJobStatusResponse>(`${this.apiUrl}/import-ibbiol/status/${jobId}`);
}
}
